export {MappingMode}						from "./textures/MappingMode";
export {Single2DTexture}					from "./textures/Single2DTexture";
export {SingleCubeTexture}				from "./textures/SingleCubeTexture";
export {TextureBase}						from "./textures/TextureBase";